/**
 * Assistant messages reference chats as markdown links of the form
 * `[Chat name](dream://chat/<URL-encoded name>)`. The markdown renderer
 * intercepts these hrefs and dispatches an event; UniPage listens and switches
 * the chat panel to the named chat.
 */
export const DREAM_CHAT_LINK_PREFIX = 'dream://chat/';

const OPEN_CHAT_EVENT = 'dream:open-chat';

export function isDreamChatLink(href: string | undefined): href is string {
  return !!href && href.startsWith(DREAM_CHAT_LINK_PREFIX);
}

export function chatNameFromLink(href: string): string {
  try {
    return decodeURIComponent(href.slice(DREAM_CHAT_LINK_PREFIX.length));
  } catch {
    return href.slice(DREAM_CHAT_LINK_PREFIX.length);
  }
}

export function requestOpenChat(name: string): void {
  window.dispatchEvent(
    new CustomEvent<{ name: string }>(OPEN_CHAT_EVENT, { detail: { name } }),
  );
}

export function onOpenChatRequest(handler: (name: string) => void): () => void {
  const listener = (e: Event) => {
    const name = (e as CustomEvent<{ name: string }>).detail?.name;
    if (name) handler(name);
  };
  window.addEventListener(OPEN_CHAT_EVENT, listener);
  return () => window.removeEventListener(OPEN_CHAT_EVENT, listener);
}
